import { entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';
import '../../common/bn-flash';

class BinMessageAddModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'bin-message-add-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#bin-message-add-modal {
          --modal-min-width: 60%;
          --modal-max-width: 80%;
        }
        h3 {
          margin: 0;
        }
      </style>

      <h3 slot="title">Add Bin Message</h3>
      <bn-flash></bn-flash>

      <bn-action
        .href="${this.href}"
        actionname="add-bin-message"
        @response="${this._onResponse}"
        @error="${this._onError}"
        suppressflash
      >
        <span slot="header"></span>
      </bn-action>
    `;
  }

  _onResponse() {
    entityStore.invalidateHref(this.href);
    this.close();
  }

  _onError(e) {
    const { message } = e.error;
    const flash = this.renderRoot.querySelector('bn-flash');

    flash.clear();
    flash.critical(html`
      Failed to create Bin Message
      <br/>
      <code>${message}</code>
    `);
  }

  open() {
    this.hide = false;
  }

  close() {
    this.hide = true;
  }
}

window.customElements.define('bin-message-add-modal', BinMessageAddModal);
